import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { mapGetters } from 'vuex';
import getJsonLD, { TYPES } from '~/helpers/json-ld';
var getCategoryJsonLD = getJsonLD(TYPES.CATEGORY);
export default {
  name: 'CategoryJsonLD',
  props: {
    category: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    image: {
      type: String,
      default: ''
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    scriptJsonLD: function scriptJsonLD() {
      var category = _objectSpread({}, this.category, {
        url: this.url,
        image: this.image
      });

      return {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(getCategoryJsonLD(category, this.locale)),
        body: true
      };
    }
  }),
  head: function head() {
    return {
      script: [this.scriptJsonLD]
    };
  },
  render: function render(h) {
    return h(null);
  }
};